
export const SearchData=[

    {
        id:1,
        
        name:"SS Sheet/Plate",
        link:'/SSsheet',  
                             
      },
      {
        id:2,
        name:"Inconel Sheet/Plate",
        link:'/InconelSheet',
      
      },
      {
        id:3,
        name:"Monel  Sheet/Plate",
        link:'/MonelSheet',

        
      },
      {
        id:4,
        name:"NICKEL Sheet/Plate",
        link:'/NickelSheet',
      },
      {
        id:5,
        name:"TITANIUM Sheet/Plate",
        link:'/titaniumSheet',
      },
      
      {
        id:6,
        name:"A-286 Sheet/Platee",
        link:'/A286Sheet',
      },
      {
        id:7,
        name:"SMO 254 Sheet/Plate",
        link:'/SMO254Sheet',
      },
      {
        id:8,
        name:"Hastelloy Sheet/Plate",
        link:'/HastelloySheet',
      },
      {
        id:9,
        name:"Alloy 20 Sheet/Plate",
        link:'/Alloy20Sheet',
      
      },
      {
        id:10,
       
        name:"Duplex Superduplex Sheet/Plate",
        link:'/DuplexSuperduplexSheet',
      },
      {
        id:11,
        
        name:"SS Coils & Stirps",
        link:'/SSCoils',                           
      
      },
      {
        id:12,
        name:"Inconel Coils & Stirps",
        link:'/InconelCoils',
      
      },
      {
        id:13,
        name:"Monel  Coils & Stirps",
        link:'/MonelCoils',
      
      
        
      },
      {
        id:14,
        name:"NICKEL Coils & Stirps",
        link:'/NickelCoils',
      
      },
      {
        id:15,
        name:"TITANIUM Coils & Stirps",
        link:'/titaniumCoils',
      
       
        
      },
      
      {
        id:16,
        name:"A-286 Coils & Stirpse",
        link:'/A286Coils',
      
      },
      {
        id:17,
        name:"SMO 254 Coils & Stirps",
        link:'/SMO254Coils',
      },
      {
        id:18,
        name:"Hastelloy Coils & Stirps",
        link:'/HastelloyCoils',
      },
      {
        id:19,
        name:"Alloy 20 Coils & Stirps",
        link:'/Alloy20Coils',
      
      },
      {
        id:20,
       
        name:"Duplex Superduplex Coils & Stirps",
        link:'/DuplexSuperduplexCoils',
      },

{
      id:21,
  name:'SS 201 Sheets & Plates',
  link:'/SS201Grade'
 
},
{
  id:23,
  name:'SS 202 Sheets & Plates',
  link:'/SS202Grade'
},
{
  id:24,
  name:'SS 301 Sheets & Plates',
  link:'/SS301Grade'
},

{
  id:25,
  name:'SS 304 Sheets & Plates',
  link:'/SS304Grade'
},
{
  id:26,
  name:' SS 304L Sheets & Plates',
  link:'/SS304LGrade'
},
{
  id:27,
  name:'SS 304H Sheets & Plates',
  link:'/SS304HGrade'
},
{
  id:29,
  name:'SS 310S Sheets & Plates',
  link:'/SS310SGrade'
},
{
  id:30,
  name:'SS 310H Sheets & Plates',
  link:'/SS310HGrade'
},
{
  id:31,
  name:'SS 316  Sheets & Plates',
  link:'/SS316HGrade'
},
{
  id:32,
  name:'SS 316Ti Sheets & Plates',
  link:'/SS316TiGrade'
},

{
  id:33,
  name:'SS 321/321H Sheets & Plates',
  link:'/SS321Grade'
},
{
  id:34,
  name:'SS 904L Sheets & Plates',
  link:'/SS904LGrade'
},

{
  id:35,
  name:'SS 409 Sheets & Plates',
  link:'/SS409Grade'
},

{
  id:36,
  name:'SS 410S Sheets & Plates',
  link:'/SS410SGrade'
},
{
  id:37,
  name:'SS 420 Sheets & Plates',
  link:'/SS420Grade'
},

{
    id:1,
    name:'SS 201 Coils & Stirps',
    link:'/SS201CoilsGrade'
  },
  {
    id:2,
    name:'SS 202 Coils & Stirps',
    link:'/SS202CoilsGrade'
  },

  {
    id:7,
    name:'SS 304 Coils & Stirps'
    ,
    link:'/SS304CoilsGrade'
  },
  {
    id:8,
    name:' SS 304L Coils & Stirps',
    link:'/SS304LCoilsGrade'
  },
  {
    id:9,
    name:'SS 304H Coils & Stirps',
    link:'/SS304HCoilsGrade'
  },
  {
    id:10,
    name:'SS 310S Coils & Stirps',
    link:'/SS310SCoilsGrade'
  },
  {
    id:11,
    name:'SS 310H Coils & Stirps',
    link:'/SS310HCoilsGrade'
  },
  {
    id:12,
    name:'SS 316  Coils & Stirps',
    link:'/SS316HCoilsGrade'
  },
  {
    id:13,
    name:'SS 316Ti Coils & Stirps',
    link:'/SS316TiCoilsGrade'
  },{
    id:14,
    name:'SS 316L  Coils & Stirps',
    link:'/SS316LCoilsGrade'
  },
  
  {
    id:16,
    name:'SS 904L Coils & Stirps',
    link:'/SS904LCoilsGrade'
  },
  
 
 
  {
    id:22,
    name:'SS 410S Coils & Stirps',
    link:'/SS410SCoilsGrade'
  },
  {
    id:23,
    name:'SS 420 Coils & Stirps',
    link:'/SS420CoilsGrade'
  },
  {
    id: 1,
    name: "Monel 400 Sheets & Plates",
    link: "/Monel400Sheets",
  },
  {
    id: 2,
    name: "Monel K500 Sheets & Plates",
    link: "/MonelK500Sheets",
  },
  {
    id: 1,
    name: "Nickel 200 Sheets & Plates",
    link: "/Nickel200Grade",
  },
  {
    id: 2,
    name: "Nickel 201 Sheets & Plates",
    link: "/Nickel201Grade",
  },
  
  {
    id: 3,
    name: "Nickel 270 Sheets & Plates",
    link: "/Nickel270Grade",
  },
  {
    id: 4,
    name: "Nickel 212 Sheets & Plates",
    link: "/Nickel212Grade",
  },
  {
    id: 5,
    name: "Nickel 222 Sheets & Plates",
    link: "/Nickel222Grade",
  },

  {
    id: 1,
    name: "Titanium Gr 1 Sheets & Plates",
    link: "/TitaniumGr1Grade",
  },
  {
    id: 2,
    name: "Titanium Gr 2 Sheets & Plates",
    link:"/TitaniumGr2Grade",
  },
  {
    id: 3,
    name: "Titanium Gr 3 Sheets & Plates",
    link: "/TitaniumGr3Grade",
  },
  {
    id: 4,
    name: "Titanium Gr 4 Sheets & Plates",
    link: "/TitaniumGr4Grade",
  },
  {
    id: 5,
    name: "Titanium Gr 5 Sheets & Plates",
    link: "/TitaniumGr5Grade",
  },
  {
    id: 1,
    name: "Hastelloy C-22 Sheets & Plates",
    link: "/HastelloyC22Sheet",
  },
  {
    id: 2,
    name: "Hastelloy C-276 Sheets & Plates",
    link:"/HastelloyC276Sheet ",
  },


  {
    id:1,
    name:'SS 304 Round Bar',
    link:'/SS304BarGrade'
  },
  {
    id:2,
    name:'SS 304L Round Bar',
    link:'/SS304LBarGrade'
  },
  {
    id:3,
    name:'SS 304H Round Bar',
    link:'/SS304HBarGrade'
  },
  
  {
    id:7,
    name:'SS 310S Round Bar'
    ,
    link:'/SS310SBarGrade'
  },
  {
    id:8,
    name:'SS 310H Round Bar',
    link:'/SS310HBarGrade'
  },
  {
    id:9,
    name:'SS 316 Round Bar',
    link:'/SS316BarGrade'
  },
  {
    id:10,
    name:'SS 316H Round Bar',
    link:'/SS316HBarGrade'
  },

  {
    id:12,
    name:' SS 316L Round Bar',
    link:'/SS316LBarGrade'
  },
  {
    id:13,
    name:'SS 316Ti Round Bar',
    link:'/SS316TiBarGrade'
  },
    
  {
    id:18,
    name:'SS 904L Round Bar',
    link:'/SS904LBarGrade'
  },
  {
    id:1,
    name:'Inconel 600 Round Bar',
    link:'/Inconel600BarGrade'
  },
  {
    id:2,
    name:'Inconel 601 Round Bar',
    link:'/Inconel601BarGrade'
  },
  {
    id:3,
    name:'Inconel 625 Round Bar',
    link:'/Inconel625BarGrade'
  },
  
  {
    id:4,
    name:'Inconel 800 Round Bar'
    ,
    link:'/Inconel800BarGrade'
  },
  {
    id:5,
    name:' Inconel 801 Round Bar',
    link:'/Inconel801BarGrade'
  },
  {
    id:6,
    name:'Inconel 825 Round Bar',
    link:'/Inconel825BarGrade'
  },
  {
    id:1,
    name:'Monel 400 Round Bar',
    link:'/Monel400BarGrade'
  },
  {
    id:2,
    name:'Monel K500 Round Bar',
    link:'/MonelK500BarGrade'
  },
  {
    id:1,
    name:"SS Round Bar",
    link:'SSRoundBar',                           
  
  },
  {
    id:2,
    name:"Inconel Round Bar",
    link:'/InconelRoundBar',
  
  },
  {
    id:3,
    name:"Monel Round Bar",
    link:'/MonelRoundBar',
    
  },
  {
    id:4,
    name:"NICKEL Round Bar",
    link:'/NickelRoundBar',
  },
  {
    id:6,
    name:"TITANIUM Round Bar",
    link:'/titaniumCRoundBar',
  
    
  },
  
  {
    id:8,
    name:"A-286 Round Bar",
    link:'/A286RoundBar',
  
  },
  {
    id:9,
    name:"SMO 254 Round Bar",
    link:'/SMO254RoundBar',
   
    
  },
  {
    id:10,
    name:"Hastelloy Round Bar",
    link:'/HastelloyRoundBar',
  
    
  },
  {
    id:5,
    name:"Alloy 20 Round Bar",
    link:'/Alloy20RoundBar',
  
    
  },
  {
    id:12,
    
    name:"Duplex Superduplex Round Bar",
    link:'/DuplexSuperduplexRoundBar',
   
    
  },
  {
    id:1,
    name:'Nickel 200 Round Bar',
    link:'/Nickel200BarGrade'
  },
  {
    id:2,
    name:'Nickel 201 Round Bar',
    link:'/Nickel201BarGrade'
  },
  {
    id: 1,
    name: "Titanium Gr 1 Round Bar",
    link: "/TitaniumGr1BarGrade",
  },
  {
    id: 2,
    name: "Titanium Gr 2 Round Bar",
    link:"/TitaniumGr2BarGrade",
  },
  {
    id: 3,
    name: "Titanium Gr 3 Round Bar",
    link: "/TitaniumGr3BarGrade",
  },
  {
    id: 4,
    name: "Titanium Gr 4 Round Bar",
    link: "/TitaniumGr4BarGrade",
  },
  {
    id: 5,
    name: "Titanium Gr 5 Round Bar",
    link: "/TitaniumGr5BarGrade",
  },
  {
    id:1,
    name:'Hastelloy C22 Round Bar',
    link:'/HastelloyC22BarGrade'
  },
  {
    id:2,
    name:'Hastelloy C276 Round Bar',
    link:'/HastelloyC276BarGrade'
  },
  {
    id:1,
    name:"SS Wire",
    link:'/SSWire',                           
  
  },
  {
    id:2,
  
    name:"Inconel Wire",
    link:'/InconelWire',
  
  },
  {
    id:3,
   
    name:"Monel Wire",
    link:'/MonelWire',
  
    
  },
  {
    id:4,
  
    name:"NICKEL Wire",
    link:'/NickelWire',
  
    
  },
  {
    id:6,
    name:"TITANIUM Wire",
    link:'/titaniumCWire',
    
  },
  {
    id:9,
  
    name:"SMO 254 Wire",
    link:'/SMO254Wire',
  },
  {
    id:10,
   
    name:"Hastelloy Wire",
    link:'/HastelloyWire',
  
    
  },
  {
    id:5,
    name:"Alloy 20 Wire",
    link:'/Alloy20Wire',
   
  },
  {
    id:12,
    name:"Duplex Superduplex Wire",
    link:'/DuplexSuperduplexWire',
    
    
  },
  {
    id:1,
    name:"SS Pipes/tubes",
    link:'/SSPipes',                           
  
  },
  {
    id:2,
    name:"Inconel Pipes/tubes",
    link:'/InconelPipes',
  
  },
  {
    id:3,
    name:"Monel  Pipes/tubes",
    link:'/MonelPipes',
  
    
  },
  {
    id:4,
    name:"NICKEL Pipes/tubes",
    link:'/NickelPipes',
  
    
  },
  {
    id:6,
  
    name:"TITANIUM Pipes/tubes",
    link:'/titaniumPipes',
  
    
  },
  
  {
    id:10,
    name:"Hastelloy Pipes/tubes",
    link:'/HastelloyPipes',
  
    
  },
  
  {
    id:12,
  
    name:"Duplex Superduplex Pipes/tubes",
    link:'/DuplexSuperduplexPipes',
  
    
  },
  {
    id:1,
    name:'Inconel 600 Sheets & Plates',
    link:'/Inconel600Grade'
  },
  {
    id:2,
    name:'Inconel 601 Sheets & Plates',
    link:'/Inconel601Grade'
  },
  {
    id:3,
    name:'Inconel 625 Sheets & Plates',
    link:'/Inconel625Grade'
  },
  
  {
    id:4,
    name:'Inconel 718 Sheets & Plates'
    ,
    link:'/Inconel718Grade'
  },
  {
    id:5,
    name:' Inconel 750 Sheets & Plates',
    link:'/Inconel750Grade'
  },
  {
    id:6,
    name:'Inconel 706 Sheets & Plates',
    link:'/Inconel706Grade'
  },
  {
      id:7,
      name:'Inconel RA330 Sheets & Plates',
      link:'/InconelRA330Grade'
    },
    {
      id: 1,
      
      name: "ANSI Norm Flanges",
      link: "/ANSI_Norm_Flanges",
     
    },
    {
      id: 2,
     
      name: "UNI Norm Flanges",
      link: "/UNI_Norm_Flanges",
      
    },
    {
      id: 3,
  
      name: "EN Norm Flanges",
      link: "/EN_Norm_Flanges",
    },
    {
      id: 4,
  
      name: "BS Norm Flanges",
      link: "/BS_Norm_Flanges",
    },
    {
      id: 5,
      
      name: "JIS Norm Flanges",
      link: "/JIS_Norm_Flangess",
     
    },
    {
      id: 6,
      
      name: "DIN Norm Flanges",
      link: "/DIN_Norm_Flanges",
      
    },
    {
      id:1,
      
      name:"Buttweld Pipe Fittings",
      link:'/Buttweld_Pipe_Fittings',                           
      
    },
    {
      id:2,
     
      name:"Threaded Pipe Fittings",
      link:'/Threaded_Pipe_Fittings',
    },
    {
      id:3,
      name:"Socket Weld  Pipe Fittings",
      link:"/MGalvanized_Pipe_Fittings",
      
    },{
      id:4,
      name:"Olets Pipe Fittings",
      link:"/Olets_Pipe_Fittings",
      
    },
    {
      id:5,
      name:"Stainless Steel",
      link:"/products/stainless_steel",
      
    },
    {
      id:6,
      name:"Mild Steel",
      link:"/products/mildSteel",
      
    },
    {
      id:7,
      name:"Carbon Steel",
      link:"/products/carbon_steel",
      
    },
    {
      id:8,
      name:"High Nickel Alloys",
      link:"/products/high_nickel_alloys",
      
    },
    {
      id:9,
      name:"Duplex Steels",
      link:"/products/duplex_steel",
      
    },
    {
      id:10,
      name:"Titanium Alloys",
      link:"/products/titanium_alloys",
      
    }
]
